import { createStore, applyMiddleware, compose } from 'redux';
import createSagaMiddleware from 'redux-saga';
import logger from 'redux-logger';
import reducers from './reducers';


const sagaMiddleware = createSagaMiddleware();

export default function configureStore(initialState = {}) {
    const env = process.env.NODE_ENV || 'development';

    // Create the store with middlewares
    const middlewares = [
        sagaMiddleware
    ];

    if (env === 'development') {
        middlewares.push(logger);
    }

    const enhancers = [
        applyMiddleware(...middlewares)
    ];

    // If Redux DevTools Extension is installed use it, otherwise use Redux compose
    /* eslint-disable no-underscore-dangle */
    const composeEnhancers =
    process.env.NODE_ENV !== 'production' &&
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
        window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;
    /* eslint-enable */

    const store = createStore(
        reducers,
        initialState,
        composeEnhancers(...enhancers)
    );

    // Extensions
    store.runSaga = sagaMiddleware.run;

    return store;
}



// WEBPACK FOOTER //
// ./app/store.js